"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInputType = exports.OffType = exports.EventType = exports.StartDateType = exports.ScheduleType = exports.DayType = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType[UserType["User"] = 0] = "User";
    UserType[UserType["Manager"] = 1] = "Manager";
    UserType[UserType["Admin"] = 2] = "Admin";
})(UserType = exports.UserType || (exports.UserType = {}));
;
var DayType;
(function (DayType) {
    DayType[DayType["None"] = 0] = "None";
    DayType[DayType["Off"] = 1] = "Off";
    DayType[DayType["On"] = 2] = "On";
})(DayType = exports.DayType || (exports.DayType = {}));
;
var ScheduleType;
(function (ScheduleType) {
    ScheduleType[ScheduleType["Inner"] = 0] = "Inner";
    ScheduleType[ScheduleType["Outer"] = 1] = "Outer";
})(ScheduleType = exports.ScheduleType || (exports.ScheduleType = {}));
/** 当月の開始日の月 */
var StartDateType;
(function (StartDateType) {
    /** 前月 */
    StartDateType[StartDateType["Previous"] = 0] = "Previous";
    /** 当月 */
    StartDateType[StartDateType["Current"] = 1] = "Current";
})(StartDateType = exports.StartDateType || (exports.StartDateType = {}));
var EventType;
(function (EventType) {
    /** 稼働日 */
    EventType[EventType["On"] = 1] = "On";
    /** 非稼働日 */
    EventType[EventType["Off"] = 2] = "Off";
})(EventType = exports.EventType || (exports.EventType = {}));
var OffType;
(function (OffType) {
    /**
     * なし
     */
    OffType[OffType["None"] = 0] = "None";
    /**
     * 年休
     */
    OffType[OffType["AnnualHoliday"] = 1] = "AnnualHoliday";
    /**
     * AM年休
     */
    OffType[OffType["AnnualHolidayAM"] = 2] = "AnnualHolidayAM";
    /**
     * PM年休
     */
    OffType[OffType["AnnualHolidayPM"] = 3] = "AnnualHolidayPM";
    /**
     * 欠勤
     */
    OffType[OffType["Absence"] = 4] = "Absence";
    /**
     * AM欠勤
     */
    OffType[OffType["AbsenceAM"] = 5] = "AbsenceAM";
    /**
     * PM欠勤
     */
    OffType[OffType["AbsencePM"] = 6] = "AbsencePM";
    /**
     * 年次特別休暇
     */
    OffType[OffType["SpecialLeaveByYear"] = 7] = "SpecialLeaveByYear";
    /**
     * 事由別特別休暇
     */
    OffType[OffType["SpecialLeaveByReason"] = 8] = "SpecialLeaveByReason";
})(OffType = exports.OffType || (exports.OffType = {}));
;
var TimeInputType;
(function (TimeInputType) {
    TimeInputType[TimeInputType["Default"] = 0] = "Default";
    TimeInputType[TimeInputType["Text"] = 1] = "Text";
})(TimeInputType = exports.TimeInputType || (exports.TimeInputType = {}));
;
